module.exports = __webpack_public_path__ + "img/ic_next_single_desktop.d1db9257.svg";